export default "__VITE_ASSET__UBraFdtL__"